"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
class MixPanel {
    init(_a) {
        var { token } = _a, config = __rest(_a, ["token"]);
        mixpanel_browser_1.default.init(token, config);
    }
    setUser({ memberId }, superProperties) {
        mixpanel_browser_1.default.register(superProperties);
        mixpanel_browser_1.default.identify(memberId.toString());
    }
    register(superProperties) {
        mixpanel_browser_1.default.register(superProperties);
    }
    unregister(superProperty) {
        mixpanel_browser_1.default.unregister(superProperty);
    }
    track(event) {
        mixpanel_browser_1.default.track(event.name, event.properties);
    }
    optOut() {
        return mixpanel_browser_1.default.opt_out_tracking({
            persistence_type: 'localStorage',
        });
    }
    optIn() {
        return mixpanel_browser_1.default.opt_in_tracking();
    }
    get people() {
        return mixpanel_browser_1.default.people;
    }
    get instance() {
        return mixpanel_browser_1.default;
    }
}
exports.default = new MixPanel();
